module.exports = __webpack_public_path__ + "static/media/tennis-is-war.f49eb799.jpg";